import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { State } from "@progress/kendo-data-query";
import { BehaviorSubject, Observable } from "rxjs";
import { map, tap } from "rxjs/operators";

import { environment } from "../../../environments/environment";
import { CustomDateFormatDirective } from "../directives/custom-date-format.directive";
import { CrossSiteUserNotificationsResults } from '../models/site-content/cross-site-user-notifications.model';
import { ProgressIndicatorService } from "./progress-indicator.service";

@Injectable({
    providedIn: 'root'
})
export class CrossSiteUserNotificationsService extends BehaviorSubject<CrossSiteUserNotificationsResults> {
    private url = environment.apiUrl;
    private endpoint: string = 'api/formInstance';
    private data: object[] = [];
    private loading = false;
    private gridData: CrossSiteUserNotificationsResults;

    public constructor(private http: HttpClient, progressIndicatorService: ProgressIndicatorService) {
        super(new CrossSiteUserNotificationsResults());
    }

    public read(gridState: State): void {
        this.fetch(gridState, 'getCrossSiteUserNotifications')
            .pipe(
                tap((data) => {
                    this.gridData = data;
                    this.loading = false;
                })
            )
            .subscribe((data) => {
                super.next(data);
            });
    }

    private fetch(gridState: State, action: string): Observable<CrossSiteUserNotificationsResults> {

        let baseUrl = this.url.endsWith('/') ? this.url : `${this.url}/`;
        let url = `${baseUrl}${this.endpoint}/${action}`;
        return <Observable<CrossSiteUserNotificationsResults>><unknown>this.http.post<CrossSiteUserNotificationsResults>(url, gridState)
            .pipe(
                map((dataFromServer) => {
                    dataFromServer.resultsAsPlainObjects = [];
                    for (let dc of dataFromServer.results) {
                        let plainObj = {
                            formId: dc.formId,
                            formName: dc.formName,
                            siteId: dc.siteId,
                            folderId: dc.folderId,
                            siteName: dc.siteName,
                            modifiedDate: CustomDateFormatDirective.applyDateFormattingUsing("yyyy-MM-dd HH:mm:ss", dc.modifiedDate.toString()),
                            modifiedBy: dc.modifiedBy,
                            //modifiedByUserName: dc.modifiedByUserName,
                            workflowState: dc.workflowState,

                            isSuscribedToWorkflowChanges: true // Because it is returned in the list from the server.
                        };
                        dataFromServer.resultsAsPlainObjects.push(plainObj);
                    }
                    return dataFromServer;
                })
            );
    }
}
